

import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible/flexible'
import Vuex from 'vuex'
import store from './store/store'
import * as mqttMsg from './mqtt/mqttMsg'
import axios from 'axios'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Popover from 'vux/src/components/popover/index.vue'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import DatetimeView from 'vux/src/components/datetime-view/index.vue'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import 'vux/src/styles/reset.less'
import { isIOS, requestWxstr, isReady } from '@/api/scanCode'
import common from '../src/common/common'
import validate from './util/validate'
import Vant from 'vant'
import 'vant/lib/index.css'




Vue.use(Vant)
Vue.use(ConfirmPlugin)
Vue.config.ignoredElements = ['wx-open-subscribe']
Vue.prototype.isWx = () => {
let ua = navigator.userAgent.toLowerCase()
return (/micromessenger/.test(ua))
}
router.beforeEach((to, from, next) => {
if (isIOS() && !isReady()) {
if (from.path === '/') {

}
if (to.meta.title) {
document.title = to.meta.title
}
}
next()
})

Vue.prototype.common = common
Vue.prototype.$http = axios
Vue.prototype.startSub = mqttMsg.startSub
Vue.prototype.sendSub = mqttMsg.sendSub
Vue.prototype.closeSub = mqttMsg.closeSub
Vue.prototype.validate = validate
Vue.prototype.golobleObject = {
changeDevicePage () {},
defenceState () {},
getLoad () {},
getDeviceMember () {},
getMqttDoor () {},
getHintOpen () {},
getStartMap () {},
getErrShow () {}
}
Vue.prototype.golobleShow = {
getClickImg () {},
addDeviceLoad () {}
}


Date.prototype.Format = function (fmt) {
const o = {
'y+': this.getFullYear(), // 年
'M+': this.getMonth() + 1, // 月份
'd+': this.getDate(), // 日
'h+': this.getHours(), // 小时
'm+': this.getMinutes(), // 分
's+': this.getSeconds(), // 秒
'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
'S': this.getMilliseconds() // 毫秒
}
if (/(y+)/.test(fmt)) {
fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
}
for (var k in o) {
if (new RegExp('(' + k + ')').test(fmt)) {
fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
}
}
return fmt
}

Vue.prototype.base = window.location.protocol === 'https:' ? 'https://' + window.location.host + '/api/wx/' : (window.location.host.split(':')[0] === 'localhost' ? 'http://af.aimtyiot.cn:48887/api/wx/' : 'http://af.aimtyiot.cn:48887/api/wx/')

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.component('tabbar', Tabbar)
Vue.component('tabbar-item', TabbarItem)
Vue.component('x-dialog', XDialog)
Vue.component('popup', Popup)
Vue.component('toast', Toast)
Vue.component('x-switch', XSwitch)
Vue.component('group', Group)
Vue.component('scroller', Scroller)
Vue.component('load-more', LoadMore)
Vue.component('popover', Popover)
Vue.component('flexbox', Flexbox)
Vue.component('flexbox-item', FlexboxItem)
Vue.component('x-button', XButton)
Vue.component('swiper', Swiper)
Vue.component('swiper-item', SwiperItem)
Vue.component('datetime-view', DatetimeView)


Array.prototype.indexOf = function (val) {
for (let i = 0; i < this.length; i++) {
if (this[i] === val) return i
}
return -1
}

Array.prototype.remove = function (val) {
let index = this.indexOf(val)
if (index > -1) {
this.splice(index, 1)
}
}
Vue.prototype.clone = function (obj) {
let copy = (obj instanceof Array) ? [] : {}
for (let attr in obj) {
if (!obj.hasOwnProperty(attr)) continue
copy[attr] = (typeof obj[attr] === 'object') ? this.clone(obj[attr]) : obj[attr]
}
return copy
}

Vue.use(LoadingPlugin)
requestWxstr()
/* eslint-disable no-new */
window.selt = new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>',
created () {

if (this.$store.getters.get_token) {
console.log('token')
this.startSub(this, this.$store.getters.get_topc)
}
},
beforeDestroy () {
this.closeSub()
}
})



// WEBPACK FOOTER //
// ./src/main.js